import { Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { login, useAuthState } from "../../../../context/UserAuthentication";
import { LoginFormFields } from "../../../../models/forms.model";
import { IAccountStatus } from "../../../../models/misc";
import { loginSchema } from "../../../../validationSchemas/loginSchema";
import { FormField } from "../../../FormFields/FormField";
import { PasswordField } from "../../../FormFields/PasswordField";
import styleClasses from "../../../../../src/containers/account/accounts.module.scss";
import Button from "../../../Buttons/Button";
import { RECAPTCHA_SITE_KEY, ROUTE_CHECKOUT } from "../../../../constants";
import { useNavigate } from "react-router";
import { setShowCart } from "../../../../redux/slices/cartSlice";
import ReCAPTCHA from 'react-google-recaptcha';
import { loginVerification } from "../../../../context/UserAuthentication/actions";
import OtpVerificationForm from "../../../../containers/account/OtpVerficationForm";

interface IEmailLogin {
  handleForgotPassword: (boolean) => void,
  closeModal: () => void
}
const EmailLogin: React.FC<IEmailLogin> = ({ handleForgotPassword, closeModal }) => {
  const { authInfo, dispatch } = useAuthState();
  const navigate = useNavigate();
  const [invalidRecaptchaMessage, setInvalidRecaptchaMessage] = useState<string>("");
  const cartDispatch = useDispatch();
  const initialFormState: LoginFormFields = {
    email: "",
    password: "",
  };
  const handleInvalidRecaptchaMessage = ({ setSubmitting }: any) => {
    if (invalidRecaptchaMessage !== "") {
      setInvalidRecaptchaMessage("");
      setSubmitting(false);
    }
  }
  const recaptchaRef = useRef(null);
  const [displayOtpForm, setDisplayOtpForm] = useState<boolean>(false);
  const [email, setEmail] = useState<string>(null);
  const [password, setPassword] = useState<string>(null);
  const [otpExpiryTime, setOtpExpiryTime] = useState<string>(null);
  const [otpModalDescription, setOtpModalDescription] = useState<string>(null);
  const handleFormSubmission = async (
    values: LoginFormFields,
    setSubmitting: any,
    isResendOtp = false
  ) => {
    const recaptchaValue = recaptchaRef?.current?.getValue();
    if (!recaptchaValue && !isResendOtp) {
      setInvalidRecaptchaMessage("Please complete the reCAPTCHA before submitting.");
      return;
    }
    setEmail(values?.email);
    setPassword(values?.password);
    const isOtpSent = await loginVerification({
      ...values, recaptcha_token: recaptchaValue,
    }, setOtpExpiryTime, dispatch, setDisplayOtpForm, setOtpModalDescription);
    if (isOtpSent) {
      setDisplayOtpForm(true);
    }
    recaptchaRef?.current?.reset();
    setSubmitting?.(false);
  }

  const handleResendOtp = async (setSubmitting) => {
    await handleFormSubmission({
      email: email,
      password: password
    }, setSubmitting, true);
  }
  
  const handleLoginWithOtp = async (
    values,
    setSubmitting: any
  ) => {
    setSubmitting(true);
    try {
      await login(
        dispatch,
        {
          platform: "web",
          email: email,
          password: password,
          otp_code: values.otp,
        },
        cartDispatch,
        updateAccountStatusModal,
        true
      );
      closeModal();
      navigate(ROUTE_CHECKOUT);
      cartDispatch(setShowCart(false));
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };
  const [accountStatusModal, setAccountStatusModal] = useState<IAccountStatus>({
    code: null,
    buttonText: null,
    isError: null,
    header: null,
    text: null,
    email: null,
    show: false,
  });
  const updateAccountStatusModal = (
    header: string,
    text: string,
    code: number,
    buttonText: string,
    email: string,
    isError: boolean
  ) => {
    setAccountStatusModal({
      code,
      buttonText,
      isError,
      header,
      text,
      email,
      show: true,
    });
  };
  return (
    <>
      <div
        className={`${styleClasses.account_content_wrapper} new_form_design pt-4 pb-0`}
      >
        {
          displayOtpForm ? 
            <div className={"app_container_wrap px-1 py-2 text-center"}>
              <span className="f-s16 font-rale">{otpModalDescription}</span>
              <OtpVerificationForm
                handleOtpVerification={handleLoginWithOtp}
                resendOtp={handleResendOtp}
                userEmail={email}
                otpExpiry={otpExpiryTime}
              /> 
            </div>
            :
            <Formik
              initialValues={initialFormState}
              validationSchema={loginSchema}
              onSubmit={handleFormSubmission}
            >
              {({ errors, touched, handleChange, isSubmitting }) => (
                <Form>
                  <FormField
                    labelText={"EMAIL ADDRESS"}
                    name="email"
                    type="email"
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                  />
                  <PasswordField
                    name="password"
                    labelText={"PASSWORD"}
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                  />
                  <a
                    onClick={handleForgotPassword}
                    className="text-end clr-dark-grey font-Visby-cf f-s14 f-w8 d-block"
                  >
                    Forgot Password?
                  </a>
                  <>
                    <hr className="my-4 d-none d-md-block" />
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={RECAPTCHA_SITE_KEY}
                      onChange={handleInvalidRecaptchaMessage}
                    />
                    <span className="clr-dark-red f-s16 font-rale">
                      {invalidRecaptchaMessage}
                    </span>
                  </>
                  <div className="pt-4">
                    <Button
                      type="submit"
                      id="sign-in-button"
                      className="d-block mb-3 w-100"
                      loading={isSubmitting}
                      disabled={isSubmitting}
                    // onClick={() => onContinueHandle()}
                    >
                      Log in
                    </Button>
                  </div>
                </Form>
              )}
            </Formik> 
        }
      </div>
    </>
  );
};

export default EmailLogin;